var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { MagicPayloadMethod, } from '@magic-sdk/types';
import { BaseModule } from './base-module';
import { createJsonRpcRequestPayload } from '../core/json-rpc';
var UserModule = /** @class */ (function (_super) {
    __extends(UserModule, _super);
    function UserModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /** */
    UserModule.prototype.getIdToken = function (configuration) {
        var requestPayload = createJsonRpcRequestPayload(MagicPayloadMethod.GetIdToken, [configuration]);
        return this.request(requestPayload);
    };
    /** */
    UserModule.prototype.generateIdToken = function (configuration) {
        var requestPayload = createJsonRpcRequestPayload(MagicPayloadMethod.GenerateIdToken, [configuration]);
        return this.request(requestPayload);
    };
    /** */
    UserModule.prototype.getMetadata = function () {
        var requestPayload = createJsonRpcRequestPayload(MagicPayloadMethod.GetMetadata);
        return this.request(requestPayload);
    };
    /** */
    UserModule.prototype.updateEmail = function (configuration) {
        var email = configuration.email, _a = configuration.showUI, showUI = _a === void 0 ? true : _a;
        var requestPayload = createJsonRpcRequestPayload(MagicPayloadMethod.UpdateEmail, [{ email: email, showUI: showUI }]);
        return this.request(requestPayload);
    };
    /** */
    UserModule.prototype.isLoggedIn = function () {
        var requestPayload = createJsonRpcRequestPayload(MagicPayloadMethod.IsLoggedIn);
        return this.request(requestPayload);
    };
    /** */
    UserModule.prototype.logout = function () {
        var requestPayload = createJsonRpcRequestPayload(MagicPayloadMethod.Logout);
        return this.request(requestPayload);
    };
    return UserModule;
}(BaseModule));
export { UserModule };
//# sourceMappingURL=user.js.map